module.exports = __webpack_public_path__ + "img/break_rules.0435fac1.png";